<script setup>
    import { updateGlobals } from '@/composables/data/updateGlobals'
    await updateGlobals()
</script>
<template>
    <div class="app-wrapper">
        <NuxtRouteAnnouncer />
        <NuxtLayout />
    </div>
</template>

<style lang="scss">
    @import '@/assets/styles/main.scss';

    .app-wrapper {
        display: flex;
        min-height: 100vh;
        flex-direction: column;
    }
</style>
